module.exports = __webpack_public_path__ + "img/test_icon10.4bd55833.png";